<template>
  <a :href="href" class="c-header-button-cart">
    <span
      :class="['c-header-button-cart__icon', { showText }]"
      :aria-label="localCartCount"
    >
      <i class="icon-cart"></i>
    </span>
    <div v-if="showText" :class="['c-header-button-cart__text', size]">
      カート
    </div>
  </a>
</template>

<script>
export default {
  name: 'ComponentHeaderButtonCart',
  props: {
    cartCount: { type: Number, default: 0 },
    href: { type: String, default: null },
    showText: { type: Boolean, default: false },
    size: { type: String, default: 'medium' },
  },
  data() {
    return {
      localCartCount: this.cartCount,
    }
  },
  created() {
    window.addEventListener('cart-added', ($event) => {
      if ($event.detail.itemCount !== undefined) {
        this.localCartCount = $event.detail.itemCount
        return
      }
      this.localCartCount = $event.detail.items.reduce((sum, item) => {
        const addedQuantity = item.addedQuantity || 0
        return (sum += Number(addedQuantity))
      }, this.localCartCount)
    })
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/variables';

.c-header-button-cart {
  display: block;
  position: relative;
  text-align: center;
  transition: opacity 0.3s;
  width: 100%;

  &:hover {
    opacity: 0.6;
  }

  &__icon {
    font-size: 20px;

    &::before {
      border-radius: 9px;
      bottom: 0;
      background-color: variables.$color-accent;
      color: #fff;
      content: attr(aria-label);
      font-size: 11px;
      height: 18px;
      left: 0;
      line-height: 18px;
      margin: auto;
      position: absolute;
      right: 0;
      top: 0;
      width: 18px;
      transform: translate(10px, -5px);
    }

    &.showText::before {
      transform: translate(10px, -12px);
    }
  }

  &__text {
    font-size: 10px;
    font-weight: 600;
    line-height: 1;
    margin-top: 4px;

    &.small {
      font-size: 8px;
      color: variables.$color-text-gray;
    }
  }
}
</style>
